module.exports = __webpack_public_path__ + "img/noun-global-care-4219366.184229ef.svg";